import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  // 美国州列表
  StateList: [
    { label: 'Alabama', value: "AL" },
    { label: 'Alaska', value: "AK" },
    { label: 'American Samoa', value: "AS" },
    { label: 'Arizona', value: "AZ" },
    { label: 'Arkansas', value: "AR" },
    { label: 'California', value: "CA" },
    { label: 'Colorado', value: "CO" },
    { label: 'Connecticut', value: "CT" },
    { label: 'Delaware', value: "DE" },
    { label: 'DistrictofColumbia', value: "DC" },
    {
      label: 'Federated States of Micronesia',
      value: "FM",
    },
    { label: 'Florida', value: "FL" },
    { label: 'Georgia', value: "GA" },
    { label: 'Guam', value: "GU" },
    { label: 'Hawaii', value: "HI" },
    { label: 'Idaho', value: "ID" },
    { label: 'Illinois', value: "IL" },
    { label: 'Indiana', value: "IN" },
    { label: 'Iowa', value: "IA" },
    { label: 'Kansas', value: "KS" },
    { label: 'Kentucky', value: "KY" },
    { label: 'Louisiana', value: "LA" },
    { label: 'Maine', value: "ME" },
    { label: 'Marshall Islands', value: "MH" },
    { label: 'Maryland', value: "MD" },
    { label: 'Massachusetts', value: "MA" },
    { label: 'Michigan', value: "MI" },
    { label: 'Minnesota', value: "MS" },
    { label: 'Mississippi', value: "MO" },
    { label: 'Missouri', value: "MT" },
    { label: 'Montana', value: "NE" },
    { label: 'Nebraska', value: "NV" },
    { label: 'Nevada', value: "NH" },
    { label: 'New Hampshire', value: "NJ" },
    { label: 'New Mexico', value: "NM" },
    { label: 'New York', value: "NY" },
    { label: 'North Carolina', value: "NC" },
    { label: 'North Dakota', value: "ND" },
    { label: 'Northern Mariana Islands', value: "MP", },
    { label: 'Ohio', value: "OH" },
    { label: 'Oklahoma', value: "OK" },
    { label: 'Oregon', value: "OR" },
    { label: 'Palau', value: "PW" },
    { label: 'Pennsylvania', value: "PA" },
    { label: 'Puerto Rico', value: "PR" },
    { label: 'Rhode Island', value: "RI" },
    { label: 'South Carolina', value: "SC" },
    { label: 'South Dakota', value: "SD" },
    { label: 'Tennessee', value: "TN" },
    { label: 'Texas', value: "TX" },
    { label: 'Utah', value: "UT" },
    { label: 'Vermont', value: "VT" },
    { label: 'Virgin Islands', value: "VI" },
    { label: 'Virginia', value: "VA" },
    { label: 'Washington', value: "WA" },
    { label: 'West Virginia', value: "WV" },
    { label: 'Wisconsin', value: "WI" },
    { label: 'Wyoming', value: "WY" },
  ],
  UrgencyLevel: [
    { label: 'Very urgent', value: 0 },
    { label: 'Urgent', value: 1 },
    { label: 'Rush', value: 2 },
    { label: 'Ordinary', value: 3 }
  ],
  PushFee: [
    { label: '1$', value: 1 },
    { label: '5$', value: 5 },
    { label: '10$', value: 10 },
    { label: '50$', value: 50 }
  ]
};

const commonrSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    // increment:(state)=>{
    //   state.value+=1;
    // },
    // decrement:(state)=>{
    //   state.value-=1;
    // },
    // changement:(state,action: PayloadAction<any>)=>{
    //   state.value += action.payload;
    // }
  },
});

// export const { increment, decrement,changement } = commonrSlice.actions;
//console.log('commonrSlice.reducer', commonrSlice.reducer);

export default commonrSlice.reducer; 